/**
 * @fileoverview gRPC-Web generated client stub for com.mu.city.api
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!

import * as grpcWeb from 'grpc-web';

import { GetCitiesByCountryRequest, GetCitiesByCountryResponse, GetCountriesRequest, GetCountriesResponse } from './city.api_pb';

export class CityControllerClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string };
  options_: null | { [index: string]: string };

  constructor(hostname: string, credentials: null | { [index: string]: string }, options: null | { [index: string]: string }) {
    if (!options) options = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoGetCitiesByCountry = new grpcWeb.AbstractClientBase.MethodInfo(
    GetCitiesByCountryResponse,
    (request: GetCitiesByCountryRequest) => {
      return request.serializeBinary();
    },
    GetCitiesByCountryResponse.deserializeBinary
  );

  getCitiesByCountry(
    request: GetCitiesByCountryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GetCitiesByCountryResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.city.api.CityController/GetCitiesByCountry',
      request,
      metadata || {},
      this.methodInfoGetCitiesByCountry,
      callback
    );
  }

  methodInfoGetCountries = new grpcWeb.AbstractClientBase.MethodInfo(
    GetCountriesResponse,
    (request: GetCountriesRequest) => {
      return request.serializeBinary();
    },
    GetCountriesResponse.deserializeBinary
  );

  getCountries(
    request: GetCountriesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GetCountriesResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.city.api.CityController/GetCountries',
      request,
      metadata || {},
      this.methodInfoGetCountries,
      callback
    );
  }
}
